export default "__VITE_ASSET__Cz8bCfL9__"